<template>
  <div id="app" :style="{'height': height}">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        height: ''
      }
    },
    mounted() {
      this.height = window.innerHeight + 'px'
    }
  }

</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    text-decoration: none;
    color: #fff
  }

  figure {
    margin: 0
  }

  img {
    content: normal !important
  }

</style>



// WEBPACK FOOTER //
// src/App.vue